import { Button, KIND, SIZE } from 'baseui/button'
import { Search } from 'baseui/icon'
import { useTranslation } from 'react-i18next'
import usePdlSearchV2 from './usePdlSearchV2'

const PdlSearchButton = ({ hidden = false }) => {
  const { t } = useTranslation()
  const { updatePdlConfigData } = usePdlSearchV2()

  const handleOpenModal = () => {
    updatePdlConfigData({ isOpen: true })
  }

  if (hidden) return null

  return (
    <Button
      overrides={{
        BaseButton: {
          style: () => ({
            marginTop: '0.1875rem',
            backgroundColor: '#F09741',
            color: 'black',
            ':hover': {
              backgroundColor: '#e8873a',
            },
          }),
        },
        StartEnhancer: {
          style: () => ({
            marginRight: '0.2rem',
          }),
        },
      }}
      kind={KIND.secondary}
      size={SIZE.mini}
      startEnhancer={() => <Search size={18} />}
      id='pdl-search-open-modal'
      onClick={handleOpenModal}
    >
      {t('subscriptionForm:pdl_module.search_text')}
    </Button>
  )
}

export default PdlSearchButton
